import { withMotionMax } from '@hoc/withMotionMax';
import FullWidthCarousel from '@stories/Components/Misc/Carousels/FullWidthCarousel/FullWidthCarousel';
import React from 'react';
import { HeroHomepageBannerStyles as S } from './HeroHomepageBanner.styles';
import HeroHomepageBannerItem from './HeroHomepageBannerItem';
const HeroHomepageBanner = ({ slides }) => {
    return (React.createElement(S.HeroHomepage, null, slides.length > 1 ? (React.createElement(FullWidthCarousel, { items: slides, noPaddingOffset: true, renderItem: (item, i) => (React.createElement(HeroHomepageBannerItem, { ...item, index: i })) })) : (React.createElement(HeroHomepageBannerItem, { ...slides[0], index: 0 }))));
};
export default withMotionMax(HeroHomepageBanner);
